import $ from 'jquery';
import 'slick-carousel';

class TopHeroSlider {
  constructor() {
    this.$slider = $('#js-hero-slider');

    if (this.$slider.length > 0) {
      this.init();
    }
  }

  init() {
    this.$slider.slick({
      arrows: true,
      appendArrows: $('.c-slider__control'),
      prevArrow: '<button type="button" class="c-slider__arrow c-slider__arrow--prev"></button>',
      nextArrow: '<button type="button" class="c-slider__arrow c-slider__arrow--next"></button>',
      appendDots: $('.c-slider__control'),
      dots:true,
      autoplay: true,
      autoplaySpeed: 4000,
    });
  }
}

export default TopHeroSlider;
